/*!
 * SPDX-FileCopyrightText: 2026 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { shallowRef } from 'vue';
/**
 * Get the sidebar state shared by all entry points of the current page.
 */
export function getSidebarSharedState() {
    window.OCA.Files ??= {};
    window.OCA.Files.Sidebar ??= {};
    window.OCA.Files.Sidebar._sharedState ??= {
        dataProvider: shallowRef(),
    };
    return window.OCA.Files.Sidebar._sharedState;
}
